const tokens = {
  "fonts.main": {
    "value": "'Suisse Intl', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    "variable": "var(--beam-fonts-main)"
  },
  "fonts.code": {
    "value": "'JetBrains Mono', monospace",
    "variable": "var(--beam-fonts-code)"
  },
  "shadows.lg": {
    "value": "0px 4px 20px rgba(0, 0, 0, 0.45)",
    "variable": "var(--beam-shadows-lg)"
  },
  "shadows.md": {
    "value": "0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px -2px 2px rgba(255, 255, 255, 0.07)",
    "variable": "var(--beam-shadows-md)"
  },
  "shadows.sm": {
    "value": "inset 0px -2px 2px rgba(255, 255, 255, 0.07), 0px 2px 2px rgba(0, 0, 0, 0.25)",
    "variable": "var(--beam-shadows-sm)"
  },
  "shadows.text": {
    "value": "0px 1px 0px rgba(255, 255, 255, 0.10)",
    "variable": "var(--beam-shadows-text)"
  },
  "shadows.neon": {
    "value": "0px 0px 10px rgba(216, 162, 239, 0.50)",
    "variable": "var(--beam-shadows-neon)"
  },
  "shadows.inner": {
    "value": "inset 0px -2px 2px 0px rgba(255, 255, 255, 0.07)",
    "variable": "var(--beam-shadows-inner)"
  },
  "shadows.border": {
    "value": "inset 0 0 0 1px var(--beam-colors-mono-900)",
    "variable": "var(--beam-shadows-border)"
  },
  "shadows.border.active": {
    "value": "inset 0 0 0 1px rgba(255, 255, 255, 0.65)",
    "variable": "var(--beam-shadows-border-active)"
  },
  "shadows.border.error": {
    "value": "inset 0 0 0 1px var(--beam-colors-red-500)",
    "variable": "var(--beam-shadows-border-error)"
  },
  "colors.mono.0": {
    "value": "#ffffff",
    "variable": "var(--beam-colors-mono-0)"
  },
  "colors.mono.100": {
    "value": "#f1f1f1",
    "variable": "var(--beam-colors-mono-100)"
  },
  "colors.mono.150": {
    "value": "#d7d7d7",
    "variable": "var(--beam-colors-mono-150)"
  },
  "colors.mono.200": {
    "value": "#dee7e1",
    "variable": "var(--beam-colors-mono-200)"
  },
  "colors.mono.250": {
    "value": "#3d3d3d",
    "variable": "var(--beam-colors-mono-250)"
  },
  "colors.mono.300": {
    "value": "#6d6d6d",
    "variable": "var(--beam-colors-mono-300)"
  },
  "colors.mono.350": {
    "value": "#272727",
    "variable": "var(--beam-colors-mono-350)"
  },
  "colors.mono.400": {
    "value": "#313131",
    "variable": "var(--beam-colors-mono-400)"
  },
  "colors.mono.450": {
    "value": "#222222",
    "variable": "var(--beam-colors-mono-450)"
  },
  "colors.mono.550": {
    "value": "#242424",
    "variable": "var(--beam-colors-mono-550)"
  },
  "colors.mono.650": {
    "value": "#151515",
    "variable": "var(--beam-colors-mono-650)"
  },
  "colors.mono.750": {
    "value": "#04040b",
    "variable": "var(--beam-colors-mono-750)"
  },
  "colors.mono.900": {
    "value": "#131313",
    "variable": "var(--beam-colors-mono-900)"
  },
  "colors.mono.1000": {
    "value": "#000000",
    "variable": "var(--beam-colors-mono-1000)"
  },
  "colors.green.400": {
    "value": "#60ff83",
    "variable": "var(--beam-colors-green-400)"
  },
  "colors.green.500": {
    "value": "#48dd13",
    "variable": "var(--beam-colors-green-500)"
  },
  "colors.red.400": {
    "value": "#ff5544",
    "variable": "var(--beam-colors-red-400)"
  },
  "colors.red.500": {
    "value": "#ff4539",
    "variable": "var(--beam-colors-red-500)"
  },
  "colors.orange.200": {
    "value": "#fea514",
    "variable": "var(--beam-colors-orange-200)"
  },
  "colors.orange.600": {
    "value": "#ff5c00",
    "variable": "var(--beam-colors-orange-600)"
  },
  "colors.purple.200": {
    "value": "#ebbcff",
    "variable": "var(--beam-colors-purple-200)"
  },
  "spacing.0": {
    "value": "0",
    "variable": "var(--beam-spacing-0)"
  },
  "spacing.1": {
    "value": ".25rem",
    "variable": "var(--beam-spacing-1)"
  },
  "spacing.2": {
    "value": ".5rem",
    "variable": "var(--beam-spacing-2)"
  },
  "spacing.3": {
    "value": ".75rem",
    "variable": "var(--beam-spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--beam-spacing-4)"
  },
  "spacing.5": {
    "value": "1.125rem",
    "variable": "var(--beam-spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--beam-spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--beam-spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--beam-spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--beam-spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--beam-spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--beam-spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--beam-spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--beam-spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--beam-spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--beam-spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--beam-spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--beam-spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--beam-spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--beam-spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--beam-spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--beam-spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--beam-spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--beam-spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--beam-spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--beam-spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--beam-spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--beam-spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--beam-spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--beam-spacing-96)"
  },
  "spacing.0.5": {
    "value": ".125rem",
    "variable": "var(--beam-spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": ".375rem",
    "variable": "var(--beam-spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": ".625rem",
    "variable": "var(--beam-spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": ".875rem",
    "variable": "var(--beam-spacing-3\\.5)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--beam-radii-none)"
  },
  "radii.xs": {
    "value": ".25rem",
    "variable": "var(--beam-radii-xs)"
  },
  "radii.sm": {
    "value": ".5rem",
    "variable": "var(--beam-radii-sm)"
  },
  "radii.md": {
    "value": ".75rem",
    "variable": "var(--beam-radii-md)"
  },
  "radii.lg": {
    "value": "1rem",
    "variable": "var(--beam-radii-lg)"
  },
  "radii.xl": {
    "value": "1.5rem",
    "variable": "var(--beam-radii-xl)"
  },
  "radii.2xl": {
    "value": "2rem",
    "variable": "var(--beam-radii-2xl)"
  },
  "radii.3xl": {
    "value": "2.5rem",
    "variable": "var(--beam-radii-3xl)"
  },
  "radii.full": {
    "value": "999rem",
    "variable": "var(--beam-radii-full)"
  },
  "durations.xxSlow": {
    "value": "2000ms",
    "variable": "var(--beam-durations-xx-slow)"
  },
  "durations.xSlow": {
    "value": "1000ms",
    "variable": "var(--beam-durations-x-slow)"
  },
  "durations.slow": {
    "value": "400ms",
    "variable": "var(--beam-durations-slow)"
  },
  "durations.normal": {
    "value": "300ms",
    "variable": "var(--beam-durations-normal)"
  },
  "durations.fast": {
    "value": "200ms",
    "variable": "var(--beam-durations-fast)"
  },
  "durations.xFast": {
    "value": "100ms",
    "variable": "var(--beam-durations-x-fast)"
  },
  "durations.none": {
    "value": "0ms",
    "variable": "var(--beam-durations-none)"
  },
  "assets.noise": {
    "value": "url(\"data:image/svg+xml,%3csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3e %3cdefs%3e %3cfilter id='grayscale'%3e %3cfeColorMatrix type='saturate' values='0' /%3e %3c/filter%3e %3c/defs%3e %3cfilter id='a'%3e %3cfeTurbulence type='fractalNoise' baseFrequency='.65' numOctaves='3' stitchTiles='stitch' /%3e %3c/filter%3e %3crect width='100%25' height='100%25' filter='url(%23a) url(%23grayscale)' opacity='0.015' /%3e %3c/svg%3e\")",
    "variable": "var(--beam-assets-noise)"
  },
  "assets.grid": {
    "value": "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3cpattern id='a' width='2' height='2' patternUnits='userSpaceOnUse'%3e%3cpath d='M2 0H0v2' fill='none' stroke='%232b2b2a'/%3e%3c/pattern%3e%3c/defs%3e%3crect width='100%25' height='100%25' fill='url(%23a)' opacity='0.6'/%3e%3c/svg%3e\")",
    "variable": "var(--beam-assets-grid)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--beam-sizes-full)"
  },
  "sizes.breakpoint-sm": {
    "value": "40rem",
    "variable": "var(--beam-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "48rem",
    "variable": "var(--beam-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "64rem",
    "variable": "var(--beam-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "80rem",
    "variable": "var(--beam-sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "96rem",
    "variable": "var(--beam-sizes-breakpoint-2xl)"
  },
  "breakpoints.sm": {
    "value": "40rem",
    "variable": "var(--beam-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "48rem",
    "variable": "var(--beam-breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "64rem",
    "variable": "var(--beam-breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "80rem",
    "variable": "var(--beam-breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "96rem",
    "variable": "var(--beam-breakpoints-2xl)"
  },
  "spacing.-0": {
    "value": "calc(var(--beam-spacing-0) * -1)",
    "variable": "var(--beam-spacing-0)"
  },
  "spacing.-1": {
    "value": "calc(var(--beam-spacing-1) * -1)",
    "variable": "var(--beam-spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--beam-spacing-2) * -1)",
    "variable": "var(--beam-spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--beam-spacing-3) * -1)",
    "variable": "var(--beam-spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--beam-spacing-4) * -1)",
    "variable": "var(--beam-spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--beam-spacing-5) * -1)",
    "variable": "var(--beam-spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--beam-spacing-6) * -1)",
    "variable": "var(--beam-spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--beam-spacing-7) * -1)",
    "variable": "var(--beam-spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--beam-spacing-8) * -1)",
    "variable": "var(--beam-spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--beam-spacing-9) * -1)",
    "variable": "var(--beam-spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--beam-spacing-10) * -1)",
    "variable": "var(--beam-spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--beam-spacing-11) * -1)",
    "variable": "var(--beam-spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--beam-spacing-12) * -1)",
    "variable": "var(--beam-spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--beam-spacing-14) * -1)",
    "variable": "var(--beam-spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--beam-spacing-16) * -1)",
    "variable": "var(--beam-spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--beam-spacing-20) * -1)",
    "variable": "var(--beam-spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--beam-spacing-24) * -1)",
    "variable": "var(--beam-spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--beam-spacing-28) * -1)",
    "variable": "var(--beam-spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--beam-spacing-32) * -1)",
    "variable": "var(--beam-spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--beam-spacing-36) * -1)",
    "variable": "var(--beam-spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--beam-spacing-40) * -1)",
    "variable": "var(--beam-spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--beam-spacing-44) * -1)",
    "variable": "var(--beam-spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--beam-spacing-48) * -1)",
    "variable": "var(--beam-spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--beam-spacing-52) * -1)",
    "variable": "var(--beam-spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--beam-spacing-56) * -1)",
    "variable": "var(--beam-spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--beam-spacing-60) * -1)",
    "variable": "var(--beam-spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--beam-spacing-64) * -1)",
    "variable": "var(--beam-spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--beam-spacing-72) * -1)",
    "variable": "var(--beam-spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--beam-spacing-80) * -1)",
    "variable": "var(--beam-spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--beam-spacing-96) * -1)",
    "variable": "var(--beam-spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--beam-spacing-0\\.5) * -1)",
    "variable": "var(--beam-spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--beam-spacing-1\\.5) * -1)",
    "variable": "var(--beam-spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--beam-spacing-2\\.5) * -1)",
    "variable": "var(--beam-spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--beam-spacing-3\\.5) * -1)",
    "variable": "var(--beam-spacing-3\\.5)"
  },
  "colors.colorPalette.0": {
    "value": "var(--beam-colors-color-palette-0)",
    "variable": "var(--beam-colors-color-palette-0)"
  },
  "colors.colorPalette.100": {
    "value": "var(--beam-colors-color-palette-100)",
    "variable": "var(--beam-colors-color-palette-100)"
  },
  "colors.colorPalette.150": {
    "value": "var(--beam-colors-color-palette-150)",
    "variable": "var(--beam-colors-color-palette-150)"
  },
  "colors.colorPalette.200": {
    "value": "var(--beam-colors-color-palette-200)",
    "variable": "var(--beam-colors-color-palette-200)"
  },
  "colors.colorPalette.250": {
    "value": "var(--beam-colors-color-palette-250)",
    "variable": "var(--beam-colors-color-palette-250)"
  },
  "colors.colorPalette.300": {
    "value": "var(--beam-colors-color-palette-300)",
    "variable": "var(--beam-colors-color-palette-300)"
  },
  "colors.colorPalette.350": {
    "value": "var(--beam-colors-color-palette-350)",
    "variable": "var(--beam-colors-color-palette-350)"
  },
  "colors.colorPalette.400": {
    "value": "var(--beam-colors-color-palette-400)",
    "variable": "var(--beam-colors-color-palette-400)"
  },
  "colors.colorPalette.450": {
    "value": "var(--beam-colors-color-palette-450)",
    "variable": "var(--beam-colors-color-palette-450)"
  },
  "colors.colorPalette.550": {
    "value": "var(--beam-colors-color-palette-550)",
    "variable": "var(--beam-colors-color-palette-550)"
  },
  "colors.colorPalette.650": {
    "value": "var(--beam-colors-color-palette-650)",
    "variable": "var(--beam-colors-color-palette-650)"
  },
  "colors.colorPalette.750": {
    "value": "var(--beam-colors-color-palette-750)",
    "variable": "var(--beam-colors-color-palette-750)"
  },
  "colors.colorPalette.900": {
    "value": "var(--beam-colors-color-palette-900)",
    "variable": "var(--beam-colors-color-palette-900)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--beam-colors-color-palette-1000)",
    "variable": "var(--beam-colors-color-palette-1000)"
  },
  "colors.colorPalette.500": {
    "value": "var(--beam-colors-color-palette-500)",
    "variable": "var(--beam-colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--beam-colors-color-palette-600)",
    "variable": "var(--beam-colors-color-palette-600)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar